import { render, staticRenderFns } from "./EmployeeModal.vue?vue&type=template&id=5efc81be&"
import script from "./EmployeeModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5efc81be')) {
      api.createRecord('5efc81be', component.options)
    } else {
      api.reload('5efc81be', component.options)
    }
    module.hot.accept("./EmployeeModal.vue?vue&type=template&id=5efc81be&", function () {
      api.rerender('5efc81be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/modules/EmployeeModal.vue"
export default component.exports